import { capitalizeFirstLetter, localisedValue } from "utils"
import { t } from "i18next"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const editedTaskLogTransformer = response => {
  const transformedData = element => {
    return {
      ...element,
      leadId: element?.taskAgainstId,
      taskStatus: {
        name: [
          element?.TaskType?.Parent?.name ? localisedValue({ object: element?.TaskType?.Parent, key: "name" }) : "",
          element?.TaskType?.name ? localisedValue({ object: element?.TaskType, key: "name" }) : "",
        ],
        date: element?.createdAt,
      },
      interest: {
        projectName: localisedValue({ object: element?.InternalInquiry?.Project, key: "name" }),
        projectDesc: [
          element?.InternalInquiry?.Type?.name
            ? localisedValue({ object: element?.InternalInquiry?.Type, key: "name" })
            : "",
          element?.InternalInquiry?.Purpose?.name
            ? localisedValue({ object: element?.InternalInquiry?.Purpose, key: "name" })
            : "",
          element?.InternalInquiry?.interestedIn
            ? t(capitalizeFirstLetter(localisedValue({ object: element?.InternalInquiry, key: "interestedIn" })))
            : "",
        ],
        projectUrl: element?.InternalInquiry?.Project?.url,
      },
      remark: {
        assignedTo: localisedValue({ object: element?.AssignedTo, key: "name" }),
        tagData: localisedValue({ object: element?.AssignedTo?.TeamMember?.Team?.TeamType, key: "name" }),
        desc: localisedValue({ object: element, key: "description" }),
        attachment: element?.Attachments?.filter(e => e.entityType !== "task_comment_audio"),
      },
      commentVoiceRecording: element?.Attachments?.find(e => e.entityType === "task_comment_audio"),
      Client: element?.InternalInquiry?.Client,
      privileges: createPrivilegeObject(element?.privileges),
      updatedByAI: element?.LogUpdatedBy?.id === -1,
    }
  }

  return response?.map(item => transformedData(item))
}

export default editedTaskLogTransformer
